(() => {
  const gczText = (text) => window.GAUCZ_I18N?.[text] ?? text;
  const clampIndex = (index, total) => (index + total) % total;

  document.querySelectorAll('[data-gcz-home-purchase]').forEach((root) => {
    const galleryItems = Array.from(root.querySelectorAll('[data-gcz-gallery-item]'));
    const galleryTabs = Array.from(root.querySelectorAll('[data-gcz-gallery-tab]'));
    const galleryStatus = root.querySelector('[data-gcz-gallery-status]');
    const galleryStage = root.querySelector('[data-gcz-gallery-stage]');
    let galleryIndex = 0;
    let touchStartX = null;

    const activateGalleryItem = (nextIndex, focusTab = false) => {
      if (!galleryItems.length || !galleryStatus) return;
      galleryIndex = clampIndex(nextIndex, galleryItems.length);
      galleryItems.forEach((item, index) => {
        item.hidden = index !== galleryIndex;
      });
      galleryTabs.forEach((tab, index) => {
        const selected = index === galleryIndex;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      galleryStatus.textContent = String(galleryIndex + 1) + gczText(' z ') + String(galleryItems.length);
      if (focusTab) galleryTabs[galleryIndex].focus();
    };

    galleryTabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateGalleryItem(index));
      tab.addEventListener('keydown', (event) => {
        const keyMap = {
          ArrowLeft: index - 1,
          ArrowRight: index + 1,
          Home: 0,
          End: galleryTabs.length - 1
        };
        if (Object.prototype.hasOwnProperty.call(keyMap, event.key)) {
          event.preventDefault();
          activateGalleryItem(keyMap[event.key], true);
        }
      });
    });

    root.querySelector('[data-gcz-gallery-prev]')?.addEventListener('click', () => activateGalleryItem(galleryIndex - 1));
    root.querySelector('[data-gcz-gallery-next]')?.addEventListener('click', () => activateGalleryItem(galleryIndex + 1));

    galleryStage?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });
    galleryStage?.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) > 40) activateGalleryItem(galleryIndex + (distance < 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });

    const colorButtons = Array.from(root.querySelectorAll('[data-gcz-home-color]'));
    const customDetails = root.querySelector('[data-gcz-home-custom]');
    const customColorButtons = Array.from(root.querySelectorAll('[data-gcz-home-custom-color]'));
    const partButtons = Array.from(root.querySelectorAll('[data-gcz-home-part]'));
    const colorFieldset = root.querySelector('.gcz-home-colors');
    const colorName = root.querySelector('[data-gcz-home-color-name]');
    const selection = root.querySelector('[data-gcz-home-selection]');
    const variantInput = root.querySelector('[data-gcz-home-variant-id]');
    const singleColorInput = root.querySelector('[data-gcz-home-single-property]');
    const partInputs = new Map(Array.from(root.querySelectorAll('[data-gcz-home-part-property]')).map((input) => [input.dataset.gczHomePartProperty, input]));
    const availability = root.querySelector('[data-gcz-home-availability]');
    const customState = root.querySelector('[data-gcz-home-custom-state]');
    const price = root.querySelector('[data-gcz-home-price]');
    const submitButton = root.querySelector('[data-gcz-home-submit]');
    const form = root.querySelector('form');
    const formStatus = root.querySelector('[data-gcz-home-form-status]');
    const currency = root.dataset.currency || 'CZK';
    const priceFormatter = new Intl.NumberFormat(window.GAUCZ_LOCALE === 'de' ? 'de-DE' : 'cs-CZ', {
        style: 'currency',
        currency,
        maximumFractionDigits: currency === 'CZK' ? 0 : 2
      });
    const parseMinorPrice = (value) => {
      if (value === undefined || value === '') return null;
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    };
    const createTier = (name) => {
      const minorPrice = parseMinorPrice(root.dataset[name + 'PriceMinor']);
      return {
        id: root.dataset[name + 'VariantId'] || '',
        minorPrice,
        formattedPrice: minorPrice === null
          ? root.dataset[name + 'Price']
          : priceFormatter.format(minorPrice / 100),
        available: root.dataset[name + 'VariantAvailable'] === 'true'
      };
    };
    const priceTiers = {
      base: createTier('base'),
      higher: createTier('higher')
    };
    const colorConfigNode = root.querySelector('[data-gaucz-color-config]');
    let colorConfig = [];

    try {
      colorConfig = JSON.parse(colorConfigNode.textContent);
    } catch (error) {
      colorConfig = [];
    }

    const colorState = new Map(colorConfig.map((color) => [color.key, color]));
    const higherColors = new Set(['sky', 'sun', 'meadow', 'blush']);
    let customMode = false;
    let activePart = partButtons[0];

    const syncPropertyMode = () => {
      singleColorInput.disabled = customMode;
      partInputs.forEach((input) => {
        input.disabled = !customMode;
      });
    };

    const enabledForHome = (colorKey) => {
      const configuredColor = colorState.get(colorKey);
      return Boolean(
        configuredColor &&
        configuredColor.enabled &&
        Array.isArray(configuredColor.products) &&
        configuredColor.products.includes('gaucz-home')
      );
    };

    const isHigherColor = (colorKey) => higherColors.has(colorKey);

    const configureColorAvailability = (button) => {
      const enabled = enabledForHome(button.dataset.colorKey);
      button.disabled = !enabled;
      button.setAttribute('aria-disabled', String(!enabled));
      const unavailable = button.querySelector('[data-gcz-home-unavailable]');
      if (unavailable) unavailable.hidden = enabled;
    };

    colorButtons.forEach(configureColorAvailability);
    customColorButtons.forEach(configureColorAvailability);

    const renderPurchaseState = (useHigherPrice) => {
      const tier = useHigherPrice ? priceTiers.higher : priceTiers.base;
      const orderable = Boolean(tier.id && tier.formattedPrice && tier.available);

      variantInput.value = tier.id;
      price.textContent = tier.formattedPrice
        ? tier.formattedPrice + gczText(' konečná cena')
        : gczText('Dočasně nedostupné');
      availability.hidden = false;
      availability.textContent = orderable ? gczText('Dostupné k objednání') : gczText('Dočasně nedostupné');
      availability.style.color = orderable ? '#2f6645' : '#8f1f1f';
      submitButton.textContent = orderable
        ? gczText('Přidat do košíku\u00a0—\u00a0') + tier.formattedPrice
        : gczText('Dočasně nedostupné');
      submitButton.disabled = !orderable;
      submitButton.dataset.orderable = String(orderable);

      if (customState) {
        customState.textContent = tier.formattedPrice
          ? gczText('Výsledná cena: ') + tier.formattedPrice + gczText(' konečná cena')
          : gczText('Výsledná cena je dočasně nedostupná');
      }
      formStatus.textContent = '';
    };

    const selectColor = (button, focusButton = false) => {
      if (!button || button.disabled) return;
      colorButtons.forEach((candidate) => {
        const selected = candidate === button;
        candidate.setAttribute('aria-checked', String(selected));
        candidate.tabIndex = selected ? 0 : -1;
      });

      const publicName = button.dataset.colorName;
      colorName.textContent = publicName;
      selection.textContent = publicName;
      singleColorInput.value = publicName;
      partButtons.forEach((partButton) => setPartColor(partButton, button.dataset.colorKey, publicName));
      renderPurchaseState(isHigherColor(button.dataset.colorKey));

      if (focusButton) button.focus();
    };

    const syncCustomColorSelection = () => {
      const activeColorKey = activePart?.dataset.colorKey;
      customColorButtons.forEach((button) => {
        const selected = button.dataset.colorKey === activeColorKey;
        button.setAttribute('aria-checked', String(selected));
        button.tabIndex = selected ? 0 : -1;
        button.setAttribute('aria-label', gczText('Nastavit barvu ') + button.dataset.colorName + gczText(' pro díl ') + activePart.dataset.partName);
      });
    };

    const activatePart = (button, focusButton = false) => {
      if (!button) return;
      activePart = button;
      partButtons.forEach((candidate) => {
        const selected = candidate === button;
        candidate.setAttribute('aria-checked', String(selected));
        candidate.tabIndex = selected ? 0 : -1;
      });
      syncCustomColorSelection();
      if (focusButton) button.focus();
    };

    const setPartColor = (partButton, colorKey, publicName) => {
      const configuredColor = colorState.get(colorKey);
      if (!partButton || !configuredColor || !enabledForHome(colorKey)) return;
      partButton.dataset.colorKey = colorKey;
      partButton.querySelector('[data-gcz-home-part-color]').textContent = publicName;
      partButton.querySelector('[data-gcz-home-part-swatch]').src = configuredColor.asset;
      partButton.setAttribute('aria-label', gczText('Upravit díl ') + partButton.dataset.partName + gczText(', aktuálně ') + publicName);
      const input = partInputs.get(partButton.dataset.partKey);
      if (input) input.value = publicName;
    };

    const renderCustomState = () => {
      const hasHigherMattress = partButtons.some((button) => (
        (button.dataset.partKey === 'full' || button.dataset.partKey === 'holes') &&
        isHigherColor(button.dataset.colorKey)
      ));
      selection.textContent = gczText('Vlastní kombinace');
      renderPurchaseState(hasHigherMattress);
      syncCustomColorSelection();
    };

    const chooseCustomColor = (button, focusButton = false) => {
      if (!button || button.disabled || !activePart) return;
      setPartColor(activePart, button.dataset.colorKey, button.dataset.colorName);
      renderCustomState();
      if (focusButton) button.focus();
    };

    const setCustomMode = (enabled) => {
      customMode = enabled;
      colorFieldset.disabled = enabled;
      colorFieldset.dataset.modeInactive = String(enabled);
      syncPropertyMode();

      if (enabled) {
        activatePart(activePart || partButtons[0]);
        renderCustomState();
      } else {
        const selectedButton = colorButtons.find((button) => button.getAttribute('aria-checked') === 'true');
        selectColor(selectedButton);
      }
    };

    colorButtons.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        selectColor(button);
      });
      button.addEventListener('keydown', (event) => {
        const activeButtons = colorButtons.filter((candidate) => !candidate.disabled);
        const activeIndex = activeButtons.indexOf(button);
        let nextButton = null;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextButton = activeButtons[clampIndex(activeIndex - 1, activeButtons.length)];
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextButton = activeButtons[clampIndex(activeIndex + 1, activeButtons.length)];
        } else if (event.key === 'Home') {
          nextButton = activeButtons[0];
        } else if (event.key === 'End') {
          nextButton = activeButtons[activeButtons.length - 1];
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectColor(button, true);
          return;
        }

        if (nextButton) {
          event.preventDefault();
          selectColor(nextButton, true);
        }
      });
      if (index > 0) button.tabIndex = -1;
    });

    partButtons.forEach((button) => {
      button.addEventListener('click', () => activatePart(button));
      button.addEventListener('keydown', (event) => {
        const currentIndex = partButtons.indexOf(button);
        let nextPart = null;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextPart = partButtons[clampIndex(currentIndex - 1, partButtons.length)];
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextPart = partButtons[clampIndex(currentIndex + 1, partButtons.length)];
        } else if (event.key === 'Home') {
          nextPart = partButtons[0];
        } else if (event.key === 'End') {
          nextPart = partButtons[partButtons.length - 1];
        }

        if (nextPart) {
          event.preventDefault();
          activatePart(nextPart, true);
        }
      });
    });

    customColorButtons.forEach((button) => {
      button.addEventListener('click', () => chooseCustomColor(button));
      button.addEventListener('keydown', (event) => {
        const activeButtons = customColorButtons.filter((candidate) => !candidate.disabled);
        const activeIndex = activeButtons.indexOf(button);
        let nextButton = null;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextButton = activeButtons[clampIndex(activeIndex - 1, activeButtons.length)];
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextButton = activeButtons[clampIndex(activeIndex + 1, activeButtons.length)];
        } else if (event.key === 'Home') {
          nextButton = activeButtons[0];
        } else if (event.key === 'End') {
          nextButton = activeButtons[activeButtons.length - 1];
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          chooseCustomColor(button, true);
          return;
        }

        if (nextButton) {
          event.preventDefault();
          chooseCustomColor(nextButton, true);
        }
      });
    });

    customDetails.addEventListener('toggle', () => setCustomMode(customDetails.open));

    const quantityInput = root.querySelector('[data-gcz-home-quantity-input]');
    const quantityMinus = root.querySelector('[data-gcz-home-quantity-minus]');
    const quantityPlus = root.querySelector('[data-gcz-home-quantity-plus]');

    const normalizeQuantity = () => {
      const parsedValue = Number.parseInt(quantityInput.value, 10);
      const quantity = Number.isFinite(parsedValue) && parsedValue >= 1 ? parsedValue : 1;
      quantityInput.value = String(quantity);
      quantityMinus.disabled = quantity <= 1;
      return quantity;
    };

    quantityMinus.addEventListener('click', () => {
      quantityInput.value = String(Math.max(1, normalizeQuantity() - 1));
      normalizeQuantity();
    });
    quantityPlus.addEventListener('click', () => {
      quantityInput.value = String(normalizeQuantity() + 1);
      normalizeQuantity();
    });
    quantityInput.addEventListener('input', () => {
      if (quantityInput.value !== '' && Number(quantityInput.value) < 1) quantityInput.value = '1';
      quantityMinus.disabled = Number(quantityInput.value) <= 1;
    });
    quantityInput.addEventListener('change', normalizeQuantity);
    quantityInput.addEventListener('blur', normalizeQuantity);

    form.addEventListener('submit', (event) => {
      normalizeQuantity();
      syncPropertyMode();
      if (submitButton.dataset.orderable !== 'true') {
        event.preventDefault();
        event.stopPropagation();
        formStatus.textContent = gczText('Vybranou konfiguraci nyní nelze vložit do košíku.');
        return;
      }

      formStatus.textContent = gczText('Přidávám do košíku…');
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;
      const observer = new MutationObserver(() => {
        if (cartDrawer.textContent.includes('The GAUCZ')) {
          formStatus.textContent = gczText('The GAUCZ byl přidán do košíku.');
          observer.disconnect();
        }
      });
      observer.observe(cartDrawer, { childList: true, subtree: true });
      window.setTimeout(() => observer.disconnect(), 5000);
    });

    // Campaign links keep the selected colour, gallery and price consistent.
    const requestedColorKey = new URLSearchParams(window.location.search).get('gcz_color');
    const initialColor = colorButtons.find((button) => button.dataset.colorKey === requestedColorKey && !button.disabled)
      || colorButtons.find((button) => button.dataset.colorKey === 'sand' && !button.disabled)
      || colorButtons.find((button) => !button.disabled);
    selectColor(initialColor);
    setCustomMode(customDetails.open);
    normalizeQuantity();
    activateGalleryItem(0);
  });
})();
